import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

import { clearUserSession } from '../auth/sessionCleanup';
import { Loading } from '../Loading';

export const LogoutPage = () => {
    const { logout } = useAuth0();

    useEffect(() => {
        clearUserSession();

        logout({
            logoutParams: {
                returnTo: window.location.origin + '/app/login',
            },
            openUrl(url) {
                window.location.assign(url);
            },
        });
    }, [logout]);

    return <Loading />;
};
